import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=ecebdb6a&scoped=true&"
import script from "./Pending.vue?vue&type=script&lang=js&"
export * from "./Pending.vue?vue&type=script&lang=js&"
import style0 from "./Pending.vue?vue&type=style&index=0&id=ecebdb6a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecebdb6a",
  null
  
)

export default component.exports